import React, { useEffect } from 'react';
// import Head from 'next/head';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonArrow from './ui/ButtonArrow';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Fade from 'react-reveal/Fade';

import FullRow from './ui/blocks/FullRow';
import LineBreak from './ui/blocks/LineBreak';

import hero from '../assets/images/index/hero.gif';
import network from '../assets/images/index/network.gif';
import hardware from '../assets/images/index/hardware.gif';
import learn from '../assets/images/index/learn.gif';

import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import infoBackground from '../assets/images/infoBackground.svg';

const useStyles = makeStyles(theme => ({
    animation: {
        maxWidth: "50em",
        minWidth: "21em",
        marginTop: "2em",
        marginLeft: "10%",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "30em"
        },
    },
    estimateButton: {
        ...theme.typography.estimate,
        backgroundColor: theme.palette.common.orange,
        backgroundImage: theme.palette.common.bgGrad1,
        height: 45,
        width: 145,
        textDecoration: "none !important",
        clipPath: "polygon(0% 50%, 15% 0%, 100% 0%, 100% 100%, 0% 100%)",
        transition: "1s",
        "&:before": {
            backgroundImage: theme.palette.common.bgGrad2,
            content: "' '",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            zIndex: "-100",
            transition: "opacity 1s",
        },
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            "&:before": {
                opacity: 1,
            },
        }
    },
    buttonContainer: {
        marginTop: "1em"
    },
    learnButtonHero: {
        ...theme.typography.estimate,
        backgroundColor: theme.palette.common.orange,
        backgroundImage: `linear-gradient(to right, #71c2f9,${theme.palette.primary.main})`,
        height: 45,
        width: 145,
        textDecoration: "none !important",
        transition: "1s",
        clipPath: "polygon(0% 50%, 15% 0%, 100% 0%, 100% 100%, 0% 100%)",
        "&:before": {
            backgroundImage: `linear-gradient(to right,${theme.palette.primary.main} , #71c2f9)`,
            content: "' '",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            zIndex: "-100",
            transition: "opacity 1s",
        },
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            "&:before": {
                opacity: 1,
            },
        }
    },
    learnButton: {
        ...theme.typography.learnButton,
        fontSize: "0.7rem",
        textDecoration: "none !important",
        height: 35,
        padding: 5,
        [theme.breakpoints.down("sm")]: {
            marginBottom: "2em"
        }
    },
    mainContainer: {
        marginTop: "0em",
        [theme.breakpoints.down("md")]: {
            marginTop: "0em"
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: "0em"
        }
    },
    heroTextContainer: {
        minWidth: "21.5em",
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0,
        }
    },
    subtitle: {
        maxWidth: "650px",
        marginBottom: "1em"
    },
    icon: {
        marginLeft: "2em",
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0
        }
    },
    revolutionCard: {
        position: "absolute",
        width: "70%",
        boxShadow: theme.shadows[10],
        borderRadius: 15,
        padding: "5em",
        [theme.breakpoints.down("sm")]: {
            paddingTop: "8em",
            paddingBottom: "8em",
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: 0,
            width: "100%"
        }
    },
    infoBackground: {
        backgroundImage: `url(${infoBackground})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "100%",
        width: "100%"
    },
    header: {
        height: 50,
    },
    img: {
        width: '100%',
    },
    company: {
        backgroundColor: "#fcfcfc",
        border: `1px solid #e5e5e5`,
        padding: "20px 5px",

        minHeight: "120px",
        marginBottom: "15px"
    },
}))

export default function LandingPage(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
    const content = props.content.index;
    const language = props.language;

    const setValue = props.setValue;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(0);
    }, [setValue]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="theme-color" content={theme.palette.primary.main} />
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <link rel="canonical" key="canonical" to="/" />
            </Head> */}

            <Grid container direction="column" className={classes.mainContainer} dir={language === "per" ? "rtl" : null}>

                <Grid item style={{
                    marginBottom: "0em",

                }}>

                    {/*-----Hero Block-----*/}
                    <Grid container direction="row" alignItems="center" justify={matchesSM ? "center" : "space-between"} style={{ height: "90vh" }}>
                        <Grid item md={6} style={{
                            paddingLeft: matchesSM ? 0 : "0em",
                            paddingRight: matchesSM ? 0 : "5em",
                            textAlign: matchesSM ? "center" : undefined
                        }}>
                            <Fade duration={1500} distance={matchesSM ? "0" : null} right>
                                <Grid item container justify={matchesSM ? "center" : "flex-start"}>
                                    <Grid item>
                                        <Typography variant="h2" align="center">
                                            {content.banner}
                                        </Typography>
                                        <Grid container justify="center" className={classes.buttonContainer}>
                                            <Grid item>
                                                <Button
                                                    component={Link}
                                                    to="/contact"
                                                    className={classes.estimateButton}
                                                    variant="contained"

                                                    style={{ marginRight: language === "per" ? 0 : 40, marginLeft: language === "per" ? 40 : 0 }}
                                                >
                                                    {content.contactLink}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button component={Link} to="/about" variant="contained" className={classes.learnButtonHero} >
                                                    <span style={{ marginRight: language === "per" ? 0 : 10, marginLeft: language === "per" ? 10 : 0 }}>{content.aboutLink}</span>
                                                    <ButtonArrow width={15} height={15} fill={theme.palette.common.white} />
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Fade>
                        </Grid>

                        <Grid item container justify={matchesSM ? "center" : "flex-end"} md={6} style={{
                            paddingLeft: matchesSM ? 0 : "5em",
                            paddingRight: matchesSM ? 0 : "1em",
                        }}>
                            <Fade duration={1500} distance={matchesSM ? "0" : null} left >
                                <Grid item>
                                    <img alt="hero" src={hero} style={{ maxWidth: "100%" }} />
                                </Grid>
                            </Fade>
                        </Grid>

                    </Grid>


                </Grid>


                <FullRow content={content.services[1]} image={network} imageW={"450px"} language={language} dir={0} />
                <LineBreak height="75px" type={0} />
                <FullRow content={content.services[2]} image={hardware} imageW={"450px"} language={language} dir={1} />
                <LineBreak height="75px" type={1} />
                <FullRow content={content.services[3]} image={learn} imageW={"450px"} language={language} dir={0} />


                <Grid item>
                    {/*-----Information Block-----*/}
                    <Grid container style={{ height: "55em" }} alignItems="center" direction="row" className={classes.infoBackground}>
                        <Grid item container
                            style={{
                                textAlign: matchesXS ? "center" : "inherit"
                            }}
                            direction={matchesXS ? "column" : "row"}
                        >
                            <Grid item sm style={{
                                marginLeft: matchesXS ? 0 : language === "per" ? "2em" : "5em",
                                marginRight: matchesXS ? 0 : language === "per" ? "5em" : "2em",
                            }}>
                                <Grid container style={{ marginBottom: matchesXS ? "10em" : 0 }} direction="column">
                                    <Typography variant="h2" style={{ color: "white" }}>{content.aboutLink}</Typography>
                                    <Typography variant="subtitle2">{content.aboutLinkSubtitle}</Typography>
                                    <Grid item>
                                        <Button
                                            component={Link}
                                            to="/about"
                                            variant="contained"

                                            className={classes.learnButtonHero}
                                            style={{ color: "white", borderColor: "white", height: 35, width: 80, marginTop: "10px" }}
                                        >
                                            <span style={{ marginRight: 10, fontSize: "0.7rem" }}>{content.learnMore}</span>
                                            <ButtonArrow width={10} height={10} fill="white" />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sm style={{
                                marginLeft: matchesXS ? 0 : language === "per" ? "5em" : "2em",
                                marginRight: matchesXS ? 0 : language === "per" ? "2em" : "5em",
                                textAlign: matchesXS ? "center" : language === "per" ? "left" : "right"
                            }}>
                                <Grid container direction="column">
                                    <Typography variant="h2" style={{ color: "white" }}>{content.contactLink}</Typography>
                                    <Typography variant="subtitle2">{content.contactLinkSubtitle}<span role="img" aria-label="waving hand">
                                        <EmojiPeopleIcon className={classes.Icon} />
                                    </span></Typography>
                                    <Grid item>
                                        <Button
                                            component={Link}
                                            to="/contact"
                                            variant="contained"

                                            className={classes.learnButtonHero}
                                            style={{ color: "white", borderColor: "white", height: 35, width: 80, marginTop: "10px" }}
                                        >
                                            <span style={{ marginRight: 10, fontSize: "0.7rem" }}>{content.learnMore}</span>
                                            <ButtonArrow width={10} height={10} fill="white" />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid >
        </React.Fragment>
    )
}